import * as React from "react";

import "./section-request-assistance.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {ConfirmDialog} from "../../../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";
import {InfoBlock}     from "../../../common/info-block/info-block";

export const SectionRequestAssistance = ({onClose, itemId, filePath}) => cs(
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    consumeContext("apis"),
    ({confirmDialog, apis}) => (
        <div className="section-request-assistance section-request-assistance-3y2">
            {InfoBlock({
                content: (
                    <div className="instruction-59f">
                        <b>Request Assistance!</b>{" "}
                        This will send your address list to a technician for manual processing.{" "}

                        <a {...{
                            onClick: async () => {
                                if (await confirmDialog.show({
                                    message: "This will close the modal and send address list data to a technician",
                                    actionName: "continue",
                                })) {
                                    const result = await apis.next.mailing.requestAssistance({fileName: filePath, itemId});
                                    if (result.result === "success") {
                                        alert(result.message);
                                        onClose();
                                    } else {
                                        alert(result.errors?.msg ?? "Unknown error");
                                    }
                                }
                            },
                            "xd-qa-type": "link",
                            "xd-qa-name": "Build Address List Continue",
                        }}>
                            Continue?
                        </a>
                    </div>
                ),
                xdQaName: "Build Address List Request Assistance",
            })}
        </div>
    ),
);
